import wx from 'weixin-js-sdk';
import https from '@/https.js'
const ShareImpl = async (option) => {
    let parm=new Object()
    parm.shareTitle=''
    parm.shareDesc=''
    parm.shareUrl=''
    parm.shareImg=''
    option=option?option:parm

    var urlparm=new Object();
    urlparm.url=window.location.href.split('#')[0];


    https.fetchPost("login/wxShare",urlparm)
      .then(res=>{
            var data=res.data.data;
            wx.config({
                debug: false,
                appId: data.appid,
                timestamp: data.timestamp,
                nonceStr: data.noncestr,
                signature: data.signature,
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage'
                ]
            });
            wx.ready(function () {
                console.log(option)
                wx.onMenuShareTimeline({//朋友圈
                    title: option.shareTitle,
                    desc: option.shareDesc,
                    link: option.shareUrl?option.shareUrl:window.location.href,
                    imgUrl: option.shareImg,
                    success: function () {
                        resetShare()
                    },
                    cancel: function () {
                    }
                });
                wx.onMenuShareAppMessage({//好友
                    title: option.shareTitle,
                    desc: option.shareDesc,
                    link: option.shareUrl?option.shareUrl:window.location.href,
                    imgUrl: option.shareImg,
                    type: '', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function () {resetShare()},
                    cancel: function () {
                    }
                });
            })
           
        
      });  

        
   
}
const resetShare = async () => {
    let prams=JSON.parse(sessionStorage.getItem('sinfo'))
    ShareImpl(prams)
}
export {ShareImpl}


// WEBPACK FOOTER //
// ./src/utils/weixinApi.js